import React from 'react';
import clsx from 'clsx';
import formStyles from '../../../../components/form/form.module.scss';
import { Input } from '../../../../components/uikit/inputs/Input.tsx';
import { MenuItem, Select } from '@mui/material';
import { Button } from '../../../../components/uikit/buttons/Button.tsx';
import { NegativeActionText } from '../../../../components/uikit/NegativeActionText.tsx';
import { FilterProps } from '../ServiceAndRepair.tsx';
import { useScopedTranslation } from '../../../../application/localization/useScopedTranslation.ts';
import ArrowDown from 'assets/icons/arrow-down-selector.svg?react';
import styles from '../ServiceAndRepair.module.scss';
import { IconButton } from '../../../../components/uikit/IconButton.tsx';
import Cross from 'assets/icons/close-button-small.svg?react';
import { tDynamic } from '../../../../helpers/tDynamic.ts';

export const Filters = (props: FilterProps) => {
  const {
    form,
    isResetButtonShow,
    resetFilters,
    id,
    name,
    language,
    languages,
    isSelectOpened,
    changeSelectState,
  } = props;

  const i18n = useScopedTranslation('Page.ServiceAndRepair');

  return (
    <form onSubmit={form.handleSubmitDefault}>
      <div
        className={clsx(
          formStyles.rowContainer,
          styles.filterContainer,
          styles.alignItemsUnset,
        )}
      >
        <Input
          testId={'id-input'}
          className={clsx(styles.borderBox, styles.width88)}
          leftHelperText={i18n.t('id')}
          {...form.register('id')}
          type={'number'}
          endAdornment={
            <div>
              {id && (
                <IconButton
                  type={'destroy'}
                  onClick={() => form.setValue('id', null)}
                >
                  <Cross />
                </IconButton>
              )}
            </div>
          }
          endAdornmentClassname={styles.endAdornmentClassname}
        />
        <Input
          testId={'name-input'}
          className={clsx(styles.borderBox, styles.width352)}
          leftHelperText={i18n.t('name')}
          {...form.register('name')}
          endAdornment={
            <div>
              {name && (
                <IconButton
                  type={'destroy'}
                  onClick={() => form.setValue('name', '')}
                >
                  <Cross />
                </IconButton>
              )}
            </div>
          }
          endAdornmentClassname={styles.endAdornmentClassname}
        />
        <div className={clsx(formStyles.rowContainer, styles.alignItemsUnset)}>
          <div className={styles.greyText}>{i18n.t('language')}</div>
          <Select
            data-test-id={'language-select'}
            open={isSelectOpened}
            onClick={() => {
              changeSelectState(true);
            }}
            onClose={(e) => {
              e.stopPropagation();
              changeSelectState(false);
            }}
            value={language}
            onChange={(e) => form.setValue('language', e.target.value)}
            className={clsx(
              formStyles.select,
              styles.borderBox,
              styles.width176,
            )}
            IconComponent={ArrowDown}
            MenuProps={{
              PaperProps: {
                className: clsx(
                  formStyles.selectBody,
                  styles.borderBox,
                  styles.width176,
                ),
              },
              disableScrollLock: true,
            }}
          >
            {languages.map((language) => (
              <MenuItem key={language} value={language}>
                {tDynamic(i18n, language)}
              </MenuItem>
            ))}
          </Select>
        </div>
        <Button
          type={'submit'}
          className={clsx(formStyles.actionButton)}
          title={i18n.t('apply')}
          testId={'filters-apply-button'}
        />
        {isResetButtonShow && (
          <NegativeActionText
            text={i18n.t('reset')}
            onClickHandler={resetFilters}
            containerClassName={styles.alignSelfCenter}
            testId={'filters-reset-button'}
          />
        )}
      </div>
    </form>
  );
};
